import './style.scss';
import { TranslationService } from '../../../services/translation.service';
import exclamationCircleRedIcon from '../../../../assets/icons/exclamation-circle-red.svg';
import DataUrlHelper from '../../../helpers/data-url.helper';

function ValidationSummary({ validationSummaryErrors, className, id }: { validationSummaryErrors: string[]; className?: string; id?: string }) {
  return (
    <div id={id || undefined} className={`validation-summary ${validationSummaryErrors.length > 0 ? 'has-validation-errors' : ''} ${className ?? ''}`} tabIndex={-1}>
      {validationSummaryErrors.length > 0 && (
        <div className="validation-error rounded position-relative border border-red p-3 p-sm-4">
          <div className="d-flex align-items-center mb-2">
            <img alt="" className="me-2" src={DataUrlHelper.encode(exclamationCircleRedIcon)} />
            <span className="h3 mb-0">{TranslationService.get('common.validation.validationsummaryheading')}</span>
          </div>
          <p>{TranslationService.get('common.validation.validationsummarydescription')}</p>
          <ol className="ms-3 mb-0">
            {validationSummaryErrors.map((validationError, index) => (
              <li key={index}>{validationError}</li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}

export default ValidationSummary;
